const PLAYER_ID_KEY = 'ace_player_id';
const PLAYER_NAME_KEY = 'ace_player_name';

const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getPlayerId = (): string => {
  let id = localStorage.getItem(PLAYER_ID_KEY);
  if (!id) {
    id = generateUUID();
    localStorage.setItem(PLAYER_ID_KEY, id);
  }
  return id;
};

export const getSavedName = (): string => {
  return localStorage.getItem(PLAYER_NAME_KEY) || '';
};

export const saveName = (name: string): void => {
  localStorage.setItem(PLAYER_NAME_KEY, name);
};
